import _slicedToArray from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import './index.css';
import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import { isAndroidBrowser, isIOSBrowser } from '@clearscore-group/lib.helpers.device';
import useLanguage from '@clearscore-group/lib.hooks.use-language';
import useMarketConfig from '@clearscore-group/lib.hooks.use-market-config-deprecated';
import ClearscoreIcon from '@clearscore/rainbow.icons.clearscore-logo-symbol';
import Text from '@clearscore/ui.rainbow.text';
import Spacer from '@clearscore/ui.rainbow.spacer';
import Button from '@clearscore/ui.rainbow.button';
import useAsyncClickout from '@clearscore-group/lib.hooks.use-async-clickout';
import { GB, EN_GB } from '@clearscore-group/lib.config.i18n';
var marketConfig = _defineProperty({}, GB, {
  isEnabled: true
});
var lang = _defineProperty({}, EN_GB, {
  defaultCtaText: 'Use the app'
});
var styles = {
  "wrapper": "wrapper--Gtbu8",
  "hasBorderTop": "hasBorderTop--lMdxN",
  "hasBorderBottom": "hasBorderBottom--TYNJo",
  "innerWrapper": "innerWrapper--627hF",
  "leftContent": "leftContent--JQMsQ",
  "iconOuterWrapper": "iconOuterWrapper--AVoei",
  "iconInnerWrapper": "iconInnerWrapper--f19Q3",
  "rightContent": "rightContent--MKp01",
  "storeCtaImage": "storeCtaImage--eD1Gi"
};
var ButtonCta = function ButtonCta(_ref) {
  var onClick = _ref.onClick,
    ctaText = _ref.ctaText;
  return /*#__PURE__*/React.createElement(Button, {
    isNarrow: true,
    isFlat: true,
    type: Button.types.SECONDARY,
    theme: Button.themes.LIGHT,
    size: Button.sizes.SMALL,
    onClick: onClick,
    dataId: "app-download-banner-cta"
  }, ctaText);
};
var ContextualAppDownloadBanner = function ContextualAppDownloadBanner(_ref2) {
  var _cx;
  var text = _ref2.text,
    playStoreLink = _ref2.playStoreLink,
    iosStoreLink = _ref2.iosStoreLink,
    hasBorderTop = _ref2.hasBorderTop,
    hasBorderBottom = _ref2.hasBorderBottom,
    onBannerClick = _ref2.onBannerClick,
    onBannerView = _ref2.onBannerView,
    setOpenModal = _ref2.setOpenModal,
    showOnDesktop = _ref2.showOnDesktop;
  var _useMarketConfig = useMarketConfig(marketConfig),
    isEnabled = _useMarketConfig.isEnabled;
  var title = text.title,
    description = text.description,
    ctaText = text.ctaText;
  var _useLanguage = useLanguage(lang),
    defaultCtaText = _useLanguage.defaultCtaText;
  var isAndroid = isAndroidBrowser();
  var isIOS = isIOSBrowser();
  var appStoreLink = isAndroid ? playStoreLink : iosStoreLink;
  var shouldShow = isEnabled && (isAndroid || isIOS || showOnDesktop);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    shouldOpenAppStoreLink = _useState2[0],
    setShouldOpenAppStoreLink = _useState2[1];
  useAsyncClickout({
    externalUrl: appStoreLink,
    trigger: shouldOpenAppStoreLink
  });
  useEffect(function () {
    if (shouldOpenAppStoreLink) {
      setShouldOpenAppStoreLink(false);
    }
  }, [shouldOpenAppStoreLink]);
  useEffect(function () {
    if (shouldShow) {
      onBannerView();
    }
  }, [shouldShow]);
  if (!shouldShow) {
    return null;
  }
  return /*#__PURE__*/React.createElement("section", {
    className: cx(styles.wrapper, (_cx = {}, _defineProperty(_cx, styles.hasBorderTop, hasBorderTop), _defineProperty(_cx, styles.hasBorderBottom, hasBorderBottom), _cx)),
    role: "banner",
    "data-qa": "contextual-app-download-banner"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.innerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.leftContent
  }, /*#__PURE__*/React.createElement(Spacer, {
    all: {
      horizontal: Spacer.spacings.MEDIUM
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.iconOuterWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.iconInnerWrapper
  }, /*#__PURE__*/React.createElement(ClearscoreIcon, null)))), /*#__PURE__*/React.createElement(Spacer, {
    all: {
      vertical: Spacer.spacings.SMALL
    }
  }, /*#__PURE__*/React.createElement(Text, {
    type: Text.types.MINI,
    weight: Text.weights.MEDIUM
  }, title), description ? /*#__PURE__*/React.createElement(Text, {
    type: Text.types.TINY,
    weight: Text.weights.THIN
  }, description) : null)), /*#__PURE__*/React.createElement("div", {
    className: styles.rightContent
  }, /*#__PURE__*/React.createElement(Spacer, {
    all: {
      horizontal: Spacer.spacings.MEDIUM
    }
  }, /*#__PURE__*/React.createElement(ButtonCta, {
    onClick: function onClick() {
      onBannerClick();
      showOnDesktop ? setOpenModal(true) : setShouldOpenAppStoreLink(true);
    },
    ctaText: ctaText || defaultCtaText,
    isAndroid: isAndroid
  })))));
};
ContextualAppDownloadBanner.defaultProps = {
  text: {
    description: null,
    ctaText: null
  },
  hasBorderTop: false,
  hasBorderBottom: false,
  setOpenModal: null,
  showOnDesktop: false
};
export default ContextualAppDownloadBanner;